import { render } from "./walletOverview.vue?vue&type=template&id=7721e67c&scoped=true&ts=true"
import script from "./walletOverview.vue?vue&type=script&lang=ts"
export * from "./walletOverview.vue?vue&type=script&lang=ts"

import "./walletOverview.vue?vue&type=style&index=0&id=7721e67c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7721e67c"]])

export default __exports__